Intl = require 'intl'
{ currentLocale } = require '@trello/locale'

formatter = null
module.exports = (num, normalRounding) ->
  formatter ?= new Intl.NumberFormat currentLocale,
    minimumFractionDigits: 2
    maximumFractionDigits: 2
  if normalRounding
    formatter.format(num)
  else
    # Trello displays prices like 9.999 as $9.99
    formatter.format(Math.floor(num * 100) / 100)
